<footer class="footer" *ngIf="!isHandset ; else mobileTemplate">
  <div class="colorBlockWrapper">
    <h6>{{webOrHandsetString}}</h6>
    <div class="colorBlock colorBlock-gray"></div>
    <div class="colorBlock colorBlock-blue"></div>
    <div class="colorBlock colorBlock-red"></div>
  </div>

  <div class="footer-content">

    <div class="pt-4 pb-4">
      <div class="col-4 pe-5 pb-1 footerCol" style="text-align: right; padding-top: 4rem; border-right: none;">
        <h6 class="footerTitle">
        Quick Links
        </h6>
          <div>
            <!-- <a href="newsletter.html" class="footer-link">Sign Up for Our Newsletter</a> -->
            <a class="footer-link" (click)="openJoinNow()">Join Now</a>
            <a href="https://researcharsenal.com/faqs/" target="_blank" rel="noopener noreferrer" class="footer-link"> <!-- TODO: Update this link to researcharsenal.com when Bark the full one is posted there -->
            FAQ
            </a>
            <a href="javascript:void(0);" (click)="launchContactForm('Support Center')" class="footer-link">Support Center</a>
            <a href="javascript:void(0);" (click)="launchContactForm('Contact Us')" class="footer-link">Contact Us</a>
            <a href="javascript:void(0);" (click)="launchContactForm(suggestChanges)" class="footer-link">{{ suggestChanges }}</a>
          </div>
        <br><br>
      </div>

      <div class="col-4 ps-1 pe-1 footerCol" style="text-align: center; border-left: 2px solid #eee;">
        <img src="../../assets/footer_logo.png" alt="Research Arsenal footer logo">
          <!-- <h5 class="footerTitle" style="letter-spacing: 5px;">
        ResearchArsenal
        </h5> -->
        <br><br>
        <h5 class="footerTitle pb-1">
          <strong>Follow Us</strong>
        </h5>
        <br>
        <h6>
          <a href="https://www.facebook.com/profile.php?id=100088090500715&sk=about"><i class="fab fa-lg fa-facebook-square fw-fw" style="margin: 0 0.25em;"></i></a>
          <a href="https://www.youtube.com/channel/UCHQbrUxjxa7bqNt0LCswDmg"><i class="fab fa-lg fa-youtube-square fw-fw" style="margin: 0 0.25em;"></i></a>
          <!-- <i class="fab fa-lg fa-linkedin fa-fw ms-1"></i>
          <i class="fab fa-lg fa-instagram fa-fw ms-1"></i> -->
        </h6>
      </div>

      <div class="footerCol col-4 ps-5" style="text-align: left; border-right: none;">
        <h6 class="footerTitle">
          Resources
        </h6>

        <div>
          <a href="javascript:void(0);" (click)="launchContactForm(reportAProblem)" class="footer-link">Report a Problem</a>
          <a (click)="redirectToAbout()" target="_blank" rel="noopener noreferrer" class="footer-link">
            About Digital Repositories
          </a>
          <a (click)="redirectToAccessibility()" target="_blank" rel="noopener noreferrer" class="footer-link">
            Accessibility Policy
          </a>
          <a (click)="redirectToTakedown()" target="_blank" rel="noopener noreferrer" class="footer-link">
            Deaccession and Takedown Policy
          </a>
          <a href="../../assets/documents/Privacy_Policy.pdf" target="_blank" rel="noopener noreferrer" class="footer-link">
            Re-use &amp; Attribution / Privacy
          </a>
        </div>

        <br><br>
      </div>

    </div>

    <div class="row no-gutters pb-4 ps-4" style="color: white; text-align: center;">

      <div class="col-3" title="Developed by Stellar Programming & Consulting, Inc.">
        <a href="https://stellarstar.com" class="me-1" target="_blank" rel="noopener noreferrer" style="vertical-align: text-bottom;">
          <img src="../../assets/Stellar_JustStar.png" alt="Developed by Stellar Programming & Consulting, Inc." style="height: 48px; filter: saturate(0)">
        </a>
        <span style="font-size: 0.85rem; display: inline-block;">Web app developed by <br><em class="Stellar">Stellar Programming &amp; Consulting, Inc.</em><br>
          <a href="https://stellarstar.com" target="_blank" rel="noopener noreferrer">StellarStar.com</a>
        </span>
      </div>

      <div class="col-6">
        <a (click)="redirectToAttributions()" target="_blank">&copy; {{ today.getFullYear() }}</a> &mdash; RESEARCH ARSENAL, All Rights Reserved
        <br>
        Powered by 
        <a href="http://stellarstarbase.com" target="_blank" rel="noopener noreferrer"><em class="Stellar">Stellar StarBase</em></a>
      </div>

      <div class="col-3 mt-3" title="Designed by The Bark Firm">
        <span class="Bark"></span>
        <a href="https://thebarkfirm.com" target="_blank" rel="noopener noreferrer"><img src="../../assets/BARKWebFooter_trimmed.png" style="height: 20px;" alt="Designed by The Bark Firm"></a>
      </div>
      
    </div>
  </div>
</footer>

<ng-template #mobileTemplate>
  <div class = 'MobileWrapper'>
    <div class="colorBlockWrapper">
      <div class="colorBlock colorBlock-gray"></div>
      <div class="colorBlock colorBlock-blue"></div>
      <div class="colorBlock colorBlock-red"></div>
    </div>

    <div class="footer-content" >

      <div class = "logo-child-parent" style="margin: auto; text-align: center;padding-top: 2em;">
        <div class = "ra-logo">
          <div class = "logo">
            <img src="../../assets/footer_logo.png" alt="Research Arsenal footer logo" width="250px">
            <!-- <h5 class="footerTitle" style="letter-spacing: 5px;">
            ResearchArsenal
            </h5> -->
          </div>
          <div class="col-12 ps-1 pe-1" style="text-align: center; margin: auto;">
            <br>
            <h6 class="footerTitle pb-1">
              <strong>Follow Us</strong>
            </h6>
            <h6>
              <a href="https://www.facebook.com/profile.php?id=100088090500715&sk=about"><i class="fab fa-lg fa-facebook-square fw-fw" style="margin: 0 0.25em;"></i></a>
              <a href="https://www.youtube.com/channel/UCHQbrUxjxa7bqNt0LCswDmg"><i class="fab fa-lg fa-youtube-square fw-fw" style="margin: 0 0.25em;"></i></a>
              <!-- <i class="fab fa-lg fa-linkedin fa-fw ms-1"></i>
              <i class="fab fa-lg fa-instagram fa-fw ms-1"></i> -->
            </h6>
          </div>
        </div>

        <div class="pt-4 pb-4" style="box-sizing: content-box; display: flex; justify-content: center;">
          <div class="col-6 pe-4 pb-1 footerCol" style = "text-align: right; ">
            <h6 class="footerTitle">
            Quick Links
            </h6>
              <div>
                <!-- <a href="newsletter.html" class="footer-link">Sign Up for Our Newsletter</a> -->
                <a class="footer-link" (click)="openJoinNow()">Join Now</a>
                <a href="https://researcharsenal.com/faqs/" target="_blank" rel="noopener noreferrer" class="footer-link"> <!-- TODO: Update this link to researcharsenal.com when Bark the full one is posted there -->
                FAQ
                </a>
                <a href="javascript:void(0);" (click)="launchContactForm('Support Center')" class="footer-link">Support Center</a>
                <a href="javascript:void(0);" (click)="launchContactForm('Contact Us')" class="footer-link">Contact Us</a>
                <a href="javascript:void(0);" (click)="launchContactForm(suggestChanges)" class="footer-link">{{ suggestChanges }}</a>
              </div>
            <br><br>
          </div>

          <div class="footerCol col-6 ps-4" style="text-align: left; border-right: none;">
            <h6 class="footerTitle">
              Resources
            </h6>
            <div>
              <a href="javascript:void(0);" (click)="launchContactForm(reportAProblem)" class="footer-link">Report a Problem</a>
              <a (click)="redirectToAbout()" target="_blank" rel="noopener noreferrer" class="footer-link">
                About Digital Repositories
              </a>
              <a (click)="redirectToAccessibility()" target="_blank" rel="noopener noreferrer" class="footer-link">
                Accessibility Policy
              </a>
              <a (click)="redirectToTakedown()" target="_blank" rel="noopener noreferrer" class="footer-link">
                Deaccession and Takedown Policy
              </a>
              <a href="../../assets/documents/Privacy_Policy.pdf" target="_blank" rel="noopener noreferrer" class="footer-link">
                Re-use &amp; Attribution / Privacy
              </a>
            </div>
            <br><br>
          </div>

        </div>
      </div>

      <div class="row no-gutters" 
        style="
          color: white; 
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;">

        <div class="col-12" title="Developed by Stellar Programming & Consulting, Inc." style="max-width: 100%;">
          <div class = "stellarLogo">
            <a href="https://stellarstar.com" class="me-1" target="_blank" rel="noopener noreferrer" style="vertical-align: text-bottom;">
              <img src="../../assets/Stellar_JustStar.png" alt="Developed by Stellar Programming & Consulting, Inc." style="height: 48px; filter: saturate(0)">
            </a>
          </div>
          <div class = "stellarText">
            <span style="font-size: 0.85rem; display: inline-block;">Web app developed by <br><em class="Stellar">Stellar Programming &amp; Consulting, Inc.</em><br>
              <a href="https://stellarstar.com" target="_blank" rel="noopener noreferrer">StellarStar.com</a>
            </span>
          </div>
        </div>

        <br>
        <br>

        <div class="col-12 mt-3" title="Designed by The Bark Firm" style="max-width: 100%;">
          <span class="Bark"></span>
          <a href="https://thebarkfirm.com" target="_blank" rel="noopener noreferrer"><img src="../../assets/BARKWebFooter_trimmed.png" style="height: 20px;" alt="Designed by The Bark Firm"></a>
        </div>

        <br>
        <br>

        <div class="col-12" style="max-width: 100%; padding-bottom: 1em;">
          <a (click)="redirectToAttributions()" target="_blank">&copy; {{ today.getFullYear() }}</a> &mdash; RESEARCH ARSENAL, All Rights Reserved
          <br>
          Powered by 
          <a href="http://stellarstarbase.com" target="_blank" rel="noopener noreferrer"><em class="Stellar">Stellar StarBase</em></a>
        </div>

      </div>
    </div>
  </div>
</ng-template>

